import { cva } from '@bedrock/ui/utils';

export const imageVariants = cva(null, {
  variants: {
    asBackground: {
      true: 'z-[-10]',
      false: null,
    },
  },
});

export const rootVariants = cva(null, {
  variants: {
    asBackground: {
      true: 'absolute inset-0 h-full w-full overflow-hidden',
      false: null,
    },
  },
});
